import React from "react";
import { twMerge } from "tailwind-merge";
export const SelectHeader = ({ className, children }) => {
    return (React.createElement("div", { className: twMerge("typography-label bg-[#F6F7F8] py-2 px-4 text-text-color", className) }, children));
};
//# sourceMappingURL=SelectHeader.js.map